import React, {
    useEffect, useRef, useState,
} from 'react'

import {NinchatQuestionnaireElement} from 'embed/types'

import {navigationWrapper} from './styles'
import {styled} from 'stitches/config'

const StyledNavigationWrapper = styled('div', navigationWrapper)

export interface QuestionnaireNavigationProps {
    elements: Array<NinchatQuestionnaireElement>
    enableMobileStacking?: boolean
    position?: 'top' | 'bottom'
    parseElement: (element: NinchatQuestionnaireElement) => React.ReactElement | null
}

export const QuestionnaireNavigation = (props: QuestionnaireNavigationProps) => {
    const {
        elements, parseElement, position, enableMobileStacking,
    } = props


    const rowRef = useRef<HTMLDivElement>(null)
    const [isWrapped, setIsWrapped] = useState(false)

    useEffect(() => {
        if (!enableMobileStacking) {
            return
        }

        const checkWrap = () => {
            const row = rowRef.current
            if (!row) {
                return
            }

            const children = Array.from(row.children) as HTMLElement[]
            if (children.length < 2) {
                setIsWrapped(false)
                return
            }

            // set width auto to be able to measure offset Top
            children.forEach((child) => {
                child.style.width = 'auto'
            })

            // Items are wrapped if any child sits on a different row (offsetTop)
            const firstTop = children[0].offsetTop
            const wrapped = children.some((child) => child.offsetTop !== firstTop)

            // remove focing any width to allow flexbox to wrap items naturally
            children.forEach((child) => {
                child.style.width = ''
            })
            setIsWrapped(wrapped)
        }

        checkWrap()

        // Re-check on resize since wrapping depends on available width
        const observer = new ResizeObserver(checkWrap)
        if (rowRef.current) {
            observer.observe(rowRef.current)
        }

        // eslint-disable-next-line consistent-return
        return () => {
            observer.disconnect()
        }
    }, [elements, enableMobileStacking])

    return (
        <StyledNavigationWrapper isSingle={elements.length === 1} isWrapped={isWrapped} position={position}>
            <div ref={rowRef}>
                {/* eslint-disable-next-line react/jsx-key, react/no-array-index-key */}
                {[...elements]?.sort(
                    (a: NinchatQuestionnaireElement, b: NinchatQuestionnaireElement) => {
                        if (!isWrapped) {
                            return 0
                        }
                        const aPrimary = a.element === 'button' && a.variant === 'primary' ? 1 : 0
                        const bPrimary = b.element === 'button' && b.variant === 'primary' ? 1 : 0
                        return bPrimary - aPrimary // primary first
                    },
                // eslint-disable-next-line react/no-array-index-key
                ).map((navElement: NinchatQuestionnaireElement, key: number) => <div key={key}>{parseElement(navElement)}</div>)}
            </div>
        </StyledNavigationWrapper>
    )
}

QuestionnaireNavigation.defaultProps = {
    enableMobileStacking: false,
    position: 'bottom',
}
